import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setOrderType } from '../actions';

export function useOrderType(orderType) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setOrderType(orderType));
    }, [dispatch, orderType]);
}